(($, Drupal) => {
  Drupal.behaviors.exam_page = {
    attach: function attach() {
      $('#genes_title').once().on('click', (e) => {
        e.preventDefault();
        $('#expandable').slideToggle();
        $('#arrow').toggleClass('open');
      });

      // eslint-disable-next-line no-undef
      once('examPageSelect', '.examPage-select').forEach(
        (el) => {
          const selectInput = $(el);
          selectInput.select2({
            dropdownCssClass: 'cb-dropdown',
            minimumResultsForSearch: Infinity,
          }).on('select2:selecting', (e) => {
            const data = e.params;
            window.location = data.args.data.element.attributes[2].value;
          });
        },
      );
    },
  };
})(jQuery, Drupal);
